<template>
  <FlameCompanionLayer
      v-if="routeReady"
      :location="route.meta.location || route.name"
      :context="{ full_path: route.fullPath, meta: route.meta }"
  >
    <router-view />
  </FlameCompanionLayer>
</template>

<script setup>
import FlameCompanionLayer from '@/portals/shared/FlameCompanionLayer.vue'
import { onBeforeMount, ref } from 'vue'
import { useFlameStore } from '@/stores/useFlameStore'
import { useForgeStore } from '@/portals/flame-companion-forge/stores/forgeStore'
import { useRoute } from 'vue-router'

const flameStore = useFlameStore()
const forgeStore = useForgeStore()
const route = useRoute()
const routeReady = ref(false)

onBeforeMount(async () => {
  const params = new URLSearchParams(window.location.search)
  const urlToken = params.get('token')
  const resumeToken = params.get('resume')

  if (urlToken) {
    // Direct flame token recovery (legacy silence return link)
    localStorage.setItem('flame-token', urlToken)
  } else if (resumeToken) {
    // Session resume: fetch session by resume_token to recover original flame token.
    // This runs before flameStore.initialize() so the recovered token lands in
    // localStorage before the store reads it.
    const { success, data } = await forgeStore.resumeSession(resumeToken)
    if (success && data?.recovery?.flame_token) {
      localStorage.setItem('flame-token', data.recovery.flame_token)
    } else if (success && data?.flame_token) {
      // Pre-threshold seeker who crossed the First Tremble in a previous tab session —
      // the session now has an identity but no resume recovery path ran.
      localStorage.setItem('flame-token', data.flame_token)
    }
  }

  // Only initialize flame identity if a token exists. Pre-threshold Forge seekers
  // have no identity yet — the Gate is quiet until the First Tremble crosses.
  if (localStorage.getItem('flame-token')) {
    await flameStore.initialize()
  }

  routeReady.value = true
})
</script>
